module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 834
// module chunks = 6